import { connect, ConnectedProps } from "react-redux";

import { withRouter } from "react-router";
import { ShopErrorButton } from "./component";
import { setOpenDatesModal } from "../../../availability/actions/actions";
import { IStoreState } from "../../../../reducers/types";
import { getVacationRentalShopSelectedListing } from "../../reducer";
const mapStateToProps = (state: IStoreState) => {
  return {
    selectedListing: getVacationRentalShopSelectedListing(state),
  };
};
const mapDispatchToProps = {
  setOpenDatesModal,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ShopErrorButtonConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedShopErrorButton = withRouter(
    connector(ShopErrorButton)
);
